import { CSSProperties } from 'react'
import { twMerge } from 'tailwind-merge'

export interface LoaderProps {
  small?: boolean
  type?: 'light' | 'dark'
  className?: string
  style?: CSSProperties
  iconClassName?: string
}

export const AudioLoaderFile = ({
  small = false,
  type = 'light',
  className,
  style,
  iconClassName,
}: LoaderProps) => (
  <div role="status" className={className} style={style}>
    <svg
      aria-hidden="true"
      className={twMerge(
        small ? 'size-5' : 'size-8',
        type === 'light'
          ? 'fill-brand-primary text-background-secondary'
          : 'fill-background-secondary text-text-primary',
        iconClassName,
      )}
      viewBox="0 0 86 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="86" height="10" rx="5" fill="#ECECEC" className="text-background-secondary" />
      <rect
        x="0"
        y="1"
        height="8"
        rx="4"
        fill="#00A0FF"
        className="animate-fillBar text-brand-primary"
      />
    </svg>
    <span className="text-xs text-text-secondary">Uploading...</span>
  </div>
)
